import React from 'react';
import './CategoryFilter.css';

const CategoryFilter = ({ categories, selectedCategory, onSelectCategory }) => {
    return (
      <div className="category-filter">
        <h3>Categories</h3>
        <ul>
          <li
            className={`category-item ${selectedCategory === '' ? 'selected' : ''}`}
            onClick={() => onSelectCategory('')}
          >
            All
          </li>
          {categories.map(category => (
            <li
              key={category}
              className={`category-item ${selectedCategory === category ? 'selected' : ''}`}
              onClick={() => onSelectCategory(category)}
            >
              {category}
            </li>
          ))}
        </ul>
      </div>
    );
  };
  
  export default CategoryFilter;
